import {styled} from "@mui/material/styles"
import {Badge} from "@mui/material"

export const FavouritesBadge = styled(Badge)(({theme}) => ({
    '[class*="MuiBadge-badge"]': {
        background: theme.uxfabric.components.badge.notification.backgroundColor,
        zIndex: 0,
        minWidth: "0.375rem",
        width: "0.375rem",
        height: "0.375rem",
        top: 0,
        right: "-0.063rem",
    },
    justifyContent: "center",
    alignContent: "center",
}))
